import React from 'react'
import { Box, Button, Link, Stack, Typography } from "@mui/material";
import { useThemeContext } from "../../../Context/ThemeContext.js";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants.js";
import { useTranslation } from "react-i18next";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { FiberManualRecord } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import './trustsafety.css';
import ImprintsPage from './imprints.js';

import { useEffect } from 'react';

const Trustsafety = () => {
  const { mode } = useThemeContext();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState('privacy');

  const containerBG = mode === "dark" ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
  const btnBG = mode === "dark" ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
  const spancolor = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
  const headingcolor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
  const headingcolor2 = mode === 'dark' ? DARKCOLORS.BodyLightBackground : LIGHTCOLORS.BodyLightBackground;
  const subtitletext = mode === 'dark' ? DARKCOLORS.GreyScale60 : LIGHTCOLORS.GreyScale60;
  const linkcolor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
  const activeBtnBG = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
  const activeBtnText = mode === 'dark' ? '#000' : '#fff';



  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className='faq-container' style={{
      backgroundColor: containerBG,
      borderRadius: "12px"
    }}>
      <div className="faq-sec">
        <Box className="back-btn-sec" style={{ display: 'flex', position: 'relative', left: '-10px', alignItems: 'end', }}>
          <Button className="back-btn"
            onClick={() => navigate("/help")}
            sx={{
              width: 38,
              height: 38,
              padding: 0,
              borderRadius: "50%",
              bgcolor: btnBG,
              minWidth: "unset",  // Prevents default min-width in MUI
              // "&:hover": { bgcolor: backgroundCard}  // Adds hover effect
            }}
          >
            <KeyboardBackspaceIcon sx={{ color: linkcolor }} />
          </Button>
          <h2 className="back-btn-text" style={{ marginBottom: '0', marginLeft: '10px' }}>{t('help.back')}</h2>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, mb: 3, mt: 2, ml: 3 }}>
          <Box style={{ position: 'relative' }}>
            <Box
              onClick={() => setActiveTab('privacy')}
              className='page-heading'
              style={{
                color: activeTab === 'privacy' ? linkcolor : subtitletext,
                cursor: 'pointer',
                padding: '10px 0',
              }}
            >
              {t('help.privacyPolicy')}
            </Box>
            {activeTab === 'privacy' && (
              <FiberManualRecord
                className='heading-dot'
                sx={{
                  color: linkcolor,
                  display: 'flex',
                  justifyContent: 'center',  justifySelf: 'center',
                  fontSize: '10px',
                  marginTop: '5px',
                }}
              />
            )}
          </Box>

          <Box style={{ position: 'relative' }}>
            <Box
              onClick={() => setActiveTab('imprints')}
              className='page-heading'
              style={{
                color: activeTab === 'imprints' ? linkcolor : subtitletext,
                cursor: 'pointer',
                padding: '10px 0',
              }}
            >
              {t('help.imprint')}
            </Box>
            {activeTab === 'imprints' && (
              <FiberManualRecord
                className='heading-dot'
                sx={{
                  color: linkcolor,
                  display: 'flex',
                  justifyContent: 'center',
                  justifySelf: 'center',
                  fontSize: '10px',
                  marginTop: '5px',
                }}
              />
            )}
          </Box>
        </Box>

        {activeTab === 'privacy' ? (   

        <Box className='faq-sec'>
          <Box alignItems="center" sx={{marginBottom: '40px',marginTop: '40px'}} className="trust-company-logo">
                      <Typography className="trust-title" style={{ color: headingcolor }}>
                        {t('term.PrivacyPolicy')}
                      </Typography>
                      <Typography style={{ color: subtitletext }} className="terms-li">
                        {t('term.Controller')}
                      </Typography>
                      <Typography style={{ color: subtitletext }} className="terms-li">
                        {t('term.Company')}
                      </Typography>
                      <Typography style={{ color: subtitletext }} className="terms-li">
                        {t('term.Address')}
                      </Typography>
                      <Typography style={{ color: subtitletext }} className="terms-li">
                        {t('term.PostalCode')}
                      </Typography>
                      <Typography style={{ color: subtitletext }} className="terms-li">
                        <span className='terms-span ' >{t('term.Phone')} </span> {t('term.PhoneNumber')}
                      </Typography>
                      <Typography style={{ color: subtitletext }} className="terms-li">
                        <span className='terms-span ' >{t('term.Email')} </span> {t('term.EmailAddress')}
                      </Typography>
                      <Typography style={{ color: subtitletext }} className="terms-li">
                        <span className='terms-span ' >{t('term.Web')} </span>
                        <Link sx={{ color: linkcolor, listStyle: 'none', textDecoration: 'none' }} href="https://www.vendinaf.com" target="_blank" >
                          {t('term.WebAddress')}
                        </Link>
                      </Typography>
                      <Typography>
          
                      </Typography>
          
          </Box>
          <h1 className="trust-title" style={{ color: headingcolor }}>  {t('help.TrustandSafety')} </h1>
          <p className="trust-sub-title" style={{ color: subtitletext }}>{t('help.TrustandSafetySubtitle')}</p>
          <p className="trust-terms" style={{ color: headingcolor }}>{t('help.TermsandConditions')}</p>

          <Box className="terms-sec">
            <ol className="terms-ol login-term">

              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: spancolor }}>
                  {t('term.PurposeLegal')}
                </span>
                {t('term.PurposeLegalText')}
              </li>

              <Typography className='terms-span sublist' style={{ color: headingcolor2 }}>
                {t('term.LegalBases')}

              </Typography>
             
              <ul id="ul-li-1"  className="terms-subol">


                <li className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>   </span>
                  {t('term.LegalBases1')}
                </li>
                <li className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>   </span>
                  {t('term.LegalBases2')}
                </li>
              </ul>


              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: spancolor }}>{t('term.GeneralInformation')}</span>
                {t('term.GeneralInformationtext')}
              </li>
              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: headingcolor2 }}>{t('term.DataControllerandContact')}</span>
                {t('term.DataControllerandContactText')}
              </li>
              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: spancolor }}> {t('term.YourRights')} </span> {t('term.YourRightsText')}
              </li>
              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: headingcolor2 }}>{t('term.DataRecipients')} </span>
                {t('term.DataRecipientsText')}
              </li>

              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: headingcolor2 }}>{t('term.DataRetentionandDeletion')} </span>
                {t('term.DataRetentionandDeletionText')}
              </li>


              <ul id="ul-li"  className="terms-subol" style={{ marginBottom: '10px',paddingLeft:"20px" }}>

                <li  className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.ContractData')} </span>
                  {t('term.ContractDataText')}
                </li>
                <li className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.LogData')} </span>
                  {t('term.LogDataText')}
                </li>
                <li className="terms-subli disc" style={{ color: subtitletext }}>
                  <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.LocationTransactionData')} </span>
                  {t('term.LocationTransactionDataText')}
                </li>

              </ul>

              
              <li className="terms-li" style={{ color: subtitletext }}>
                <span className='terms-span' style={{ color: headingcolor2 }}>{t('term.TypesOfDataProcessed')} </span>
                {t('term.TypesOfDataProcessedText')}
              </li>
            </ol>

            <ul className="terms-subol" style={{ marginTop: '10px' }}>
              <li className="terms-subli disc" style={{ color: subtitletext }}>
                <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.DataProcessed')}</span>
                {t('term.DataProcessedText')}
              </li>
              <li className="terms-subli disc" style={{ color: subtitletext }}>
                <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.ProcessingPurposes')}</span>
                {t('term.ProcessingPurposesText')}
              </li>
              <li className="terms-subli disc" style={{ color: subtitletext }}>
                <span className='terms-span sublist' style={{ color: headingcolor2 }}>{t('term.LegalBasisforProcessing')}</span>
                {t('term.LegalBasisforProcessingText')}
              </li>
            </ul>


            <ol className="terms-ol login-term" start={8}>
              {[
                ['AIPoweredFeaturesandMachineLearning', 'AIPoweredFeaturesandMachineLearningText'],
                ['DataSharing', 'DataSharingText'],
                ['Hosting', 'HostingText'],
                ['DataSecurity', 'DataSecurityText'],
                ['InternationalDataTransfers', 'InternationalDataTransfersText'],
                ['UserRights', 'UserRightsText'],
                ['TerminationandAccount', 'TerminationandAccountText'],
                ['LawandJurisdiction', 'LawandJurisdictionText'],
              ].map(([titleKey, textKey]) => (
                <li key={titleKey} className="terms-li" style={{ color: subtitletext }}>
                  <span className='terms-span' style={{ color: headingcolor2 }}>{t(`term.${titleKey}`)}</span>
                  {t(`term.${textKey}`)}
                </li>
              ))}
            </ol>

          </Box>
          {/* terms of use */}
          <Box className="security-sec" sx={{ margin: '100px 0px' }}>
            <h1 className="trust-terms" style={{ color: headingcolor }}>{t('term.TermsofUse')}</h1>


            <ol className="terms-ol login-term">
              {[
                ['Scope', 'ScopeText'],
                ['SubjectContract', 'SubjectContractText'],
                ['Registration_Access', 'Registration_AccessText'],
                ['CustomerObligations', 'CustomerObligationsText'],
                ['Availability', 'AvailabilityText'],
                ['Liability', 'LiabilityText'],
                ['ContractDurationTermination', 'ContractDurationTerminationText'],
                ['DataProtection', 'DataProtectionText']

              ].map(([titleKey, textKey]) => (
                <li key={titleKey} className="terms-li" style={{ color: subtitletext }}>
                  <span className='terms-span' style={{ color: headingcolor2 }}>{t(`term.${titleKey}`)}</span>
                  {t(`term.${textKey}`)}
                </li>
              ))}
            </ol>
          </Box>
          {/* security */}
          <Box className="security-sec" sx={{ margin: '100px 0px' }}>
            <h1 className="trust-terms" style={{ color: headingcolor }}>{t('term.Security')}</h1>
            <p className="trust-sub-title" style={{ color: subtitletext }}>{t('term.SecurityText')}</p>

            <ol className="terms-ol login-term">
              {[
                ['DataEncryption', 'DataEncryptionText'],
                ['AccessControl', 'AccessControlText'],
                ['RegularSecurityAudits', 'RegularSecurityAuditsText'],
                ['Compliance', 'ComplianceText']
              ].map(([titleKey, textKey]) => (
                <li key={titleKey} className="terms-li" style={{ color: subtitletext }}>
                  <span className='terms-span' style={{ color: headingcolor2 }}>{t(`term.${titleKey}`)}</span>
                  {t(`term.${textKey}`)}
                </li>
              ))}
            </ol>
          </Box>
          {/* changes */}
          <Box className="security-sec" sx={{ margin: '100px 0px' }}>
            <h1 className="trust-terms" style={{ color: headingcolor }}>{t('term.LoginNotice')}</h1>
            <p className="trust-sub-title" style={{ color: subtitletext }}>{t('term.LoginNoticeText')}</p>
            <p className="trust-sub-title" style={{ color: subtitletext }}>{t('term.LoginNoticeMandatory')}</p>


          </Box>

          <Box className="attr-sec">
            <h1 className="trust-terms" style={{ color: headingcolor }}>{t('term.Attribution')}</h1>
            <p className="trust-sub-title" style={{ color: subtitletext }}>{t('term.AttributionText')}</p>

            <ol className="terms-ol login-term">
              {[
                ['Freepik', 'FreepikText'],
                ['FigmaCommunity', 'FigmaCommunityText'],
                ['NounProject', 'NounProjectText']
              ].map(([titleKey, textKey]) => (
                <li key={titleKey} className="terms-li" style={{ color: subtitletext }}>
                  <span className='terms-span' style={{ color: headingcolor2 }}>{t(`term.${titleKey}`)}</span>
                  {t(`term.${textKey}`)}
                </li>
              ))}
            </ol>
          </Box>
        </Box>
        ) : (
          // <Box className='faq-sec'>
          //   <h1 className="trust-title" style={{ color: headingcolor }}>Imprints</h1>
          //   <p className="trust-sub-title" style={{ color: subtitletext }}>
          //     Company imprints and legal information will be displayed here.
          //   </p>
          //   {/* Add your imprints content here */}
          <ImprintsPage/>
        )}
      </div>
    </div>
  )
}

export default Trustsafety